import { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap";
import StorageInfoList from "./StorageInfoList";
import StorageFilesView from "./StorageFilesView";


const StorageFiles = (props) => {

    const [storageId, setStorageId] = useState(null);
    const [rootFolder, setRootFolder] = useState(null);
    const [cloudType, setCloudType] = useState("");


    useEffect(() => {

    }, [props])

    const _getStorageInfo = (item, root) => {
        setStorageId(item.id)
        setRootFolder(root)
        setCloudType(item.provisionerType)
    }

    const _getSelectedFiles = (data) => {
        props._getSelectedFiles(data, props.selectFromLocation)
    }

    const _getStorageOperationInfo = (path) => {
        let data = {
            destinationStorageId: storageId,
            destinationRootFolder: rootFolder,
            destinationCloudType: cloudType,
            destinationPath: path
        }
        props._getStorageDetail(data)
    }



    return (
        <Row className="p-0 m-0 g-0 flex-nowrap" style={{ width: "100%", height: "100%", minHeight: 0 }}>
            <Col
                className="p-0 sa-storage-type"
                style={{ flex: "0 0 280px", maxWidth: 280, height: "100%", minHeight: 0, overflow: "hidden" }}
            >
                <StorageInfoList
                    storageId={props.storageId}
                    _getStorageInfo={_getStorageInfo} />
            </Col>

            <Col
                className="sa-storage-list border-left p-0"
                style={{ flex: 1, height: "100%", minHeight: 0, minWidth: 0, display: "flex", flexDirection: "column" }}
            >
                <div style={{ flex: 1, minHeight: 0, minWidth: 0}}>
                    {storageId !== null && <StorageFilesView
                        storageId={storageId}
                        rootFolder={rootFolder}
                        cloudType={cloudType}
                        showSelectBox={props.showSelectBox}
                        selectedData={props.selectedData}
                        actionFooter={props.actionFooter}
                        _getSelectedFiles={_getSelectedFiles}
                        buttonText={props.buttonText !== undefined ? props.buttonText : "Save"}
                        selectFromLocation={props.selectFromLocation}
                        _getStorageOperationInfo={_getStorageOperationInfo}
                    />}
                </div>
            </Col>
        </Row>
    )

}

export default StorageFiles;